/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * DnR API
 * 地方自治体事業管理システムAPI
 * OpenAPI spec version: 1.0.0
 */

import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { useMutation, useQuery } from '@tanstack/react-query';
import type { BodyType, ErrorType } from '../../../../shared/api/custom-instance';

import { customInstance } from '../../../../shared/api/custom-instance';
import type {
  ErrorResponse,
  IdResponse,
  ListTenantDivisionsParams,
  SuccessResponse,
  TenantDivisionCreateRequest,
  TenantDivisionListResponse,
  TenantDivisionUpdateRequest,
  Uuid,
} from './model';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * テナント内の課（組織）一覧を取得します。
テナント管理者権限が必要です。

 * @summary 課一覧取得
 */
export const listTenantDivisions = (
  params?: ListTenantDivisionsParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<TenantDivisionListResponse>(
    { url: `/tenants/divisions`, method: 'GET', params, signal },
    options,
  );
};

export const getListTenantDivisionsQueryKey = (params?: ListTenantDivisionsParams) => {
  return [`/tenants/divisions`, ...(params ? [params] : [])] as const;
};

export const getListTenantDivisionsQueryOptions = <
  TData = Awaited<ReturnType<typeof listTenantDivisions>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ListTenantDivisionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listTenantDivisions>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListTenantDivisionsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listTenantDivisions>>> = ({ signal }) =>
    listTenantDivisions(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listTenantDivisions>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListTenantDivisionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listTenantDivisions>>
>;
export type ListTenantDivisionsQueryError = ErrorType<ErrorResponse>;

export function useListTenantDivisions<
  TData = Awaited<ReturnType<typeof listTenantDivisions>>,
  TError = ErrorType<ErrorResponse>,
>(
  params: undefined | ListTenantDivisionsParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listTenantDivisions>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listTenantDivisions>>,
          TError,
          Awaited<ReturnType<typeof listTenantDivisions>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListTenantDivisions<
  TData = Awaited<ReturnType<typeof listTenantDivisions>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ListTenantDivisionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listTenantDivisions>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listTenantDivisions>>,
          TError,
          Awaited<ReturnType<typeof listTenantDivisions>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListTenantDivisions<
  TData = Awaited<ReturnType<typeof listTenantDivisions>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ListTenantDivisionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listTenantDivisions>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary 課一覧取得
 */

export function useListTenantDivisions<
  TData = Awaited<ReturnType<typeof listTenantDivisions>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ListTenantDivisionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listTenantDivisions>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListTenantDivisionsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * 新しい課（組織）を作成します。
テナント管理者権限が必要です。

 * @summary 課作成
 */
export const createTenantDivision = (
  tenantDivisionCreateRequest: BodyType<TenantDivisionCreateRequest>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<IdResponse>(
    {
      url: `/tenants/divisions`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: tenantDivisionCreateRequest,
      signal,
    },
    options,
  );
};

export const getCreateTenantDivisionMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createTenantDivision>>,
    TError,
    { data: BodyType<TenantDivisionCreateRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createTenantDivision>>,
  TError,
  { data: BodyType<TenantDivisionCreateRequest> },
  TContext
> => {
  const mutationKey = ['createTenantDivision'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createTenantDivision>>,
    { data: BodyType<TenantDivisionCreateRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return createTenantDivision(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateTenantDivisionMutationResult = NonNullable<
  Awaited<ReturnType<typeof createTenantDivision>>
>;
export type CreateTenantDivisionMutationBody = BodyType<TenantDivisionCreateRequest>;
export type CreateTenantDivisionMutationError = ErrorType<ErrorResponse>;

/**
 * @summary 課作成
 */
export const useCreateTenantDivision = <TError = ErrorType<ErrorResponse>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createTenantDivision>>,
      TError,
      { data: BodyType<TenantDivisionCreateRequest> },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createTenantDivision>>,
  TError,
  { data: BodyType<TenantDivisionCreateRequest> },
  TContext
> => {
  const mutationOptions = getCreateTenantDivisionMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * 指定した課（組織）の情報を更新します。
テナント管理者権限が必要です。

 * @summary 課更新
 */
export const updateTenantDivision = (
  divisionId: Uuid,
  tenantDivisionUpdateRequest: BodyType<TenantDivisionUpdateRequest>,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<SuccessResponse>(
    {
      url: `/tenants/divisions/${divisionId}`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: tenantDivisionUpdateRequest,
    },
    options,
  );
};

export const getUpdateTenantDivisionMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateTenantDivision>>,
    TError,
    { divisionId: Uuid; data: BodyType<TenantDivisionUpdateRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateTenantDivision>>,
  TError,
  { divisionId: Uuid; data: BodyType<TenantDivisionUpdateRequest> },
  TContext
> => {
  const mutationKey = ['updateTenantDivision'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateTenantDivision>>,
    { divisionId: Uuid; data: BodyType<TenantDivisionUpdateRequest> }
  > = (props) => {
    const { divisionId, data } = props ?? {};

    return updateTenantDivision(divisionId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateTenantDivisionMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateTenantDivision>>
>;
export type UpdateTenantDivisionMutationBody = BodyType<TenantDivisionUpdateRequest>;
export type UpdateTenantDivisionMutationError = ErrorType<ErrorResponse>;

/**
 * @summary 課更新
 */
export const useUpdateTenantDivision = <TError = ErrorType<ErrorResponse>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateTenantDivision>>,
      TError,
      { divisionId: Uuid; data: BodyType<TenantDivisionUpdateRequest> },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateTenantDivision>>,
  TError,
  { divisionId: Uuid; data: BodyType<TenantDivisionUpdateRequest> },
  TContext
> => {
  const mutationOptions = getUpdateTenantDivisionMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
